import React, { forwardRef } from "react";
import { accessProperty, getRandomNumber } from "../../Helpers/utils/utils";
import { hasValue } from "../../Helpers/validations/common";
import "./BasicTable.scss";

const BasicTable = forwardRef(
  ({ title, columns, datasource, onRowOver, onRowOut, onRowClick }, ref) => {
    const renderHeaderColumns = () => {
      let htmlColumns = [];
      columns.forEach((col) => {
        const cSize = hasValue(col.size) ? col.size : "normal";
        const cAlign = hasValue(col.textAlign) ? col.textAlign : "left";

        htmlColumns.push(
          <div
            className={`basic-table-column align-${cAlign} basic-table-header-column cell-${cSize}`}
            title={col.headerCaption}
            key={
              "basic-table-header-column-" +
              getRandomNumber() +
              "-" +
              getRandomNumber()
            }
          >
            {col.headerCaption}
          </div>
        );
      });
      return htmlColumns;
    };

    const renderColumns = (row, rowIndex) => {
      let htmlColumns = [];
      columns.forEach((col) => {
        const val = accessProperty(row, col.name);
        const cSize = hasValue(col.size) ? col.size : "normal";
        const cAlign = hasValue(col.textAlign) ? col.textAlign : "left";

        htmlColumns.push(
          <div
            className={`basic-table-column align-${cAlign} cell-${cSize}`}
            title={val}
            key={
              "basic-table-column-" +
              getRandomNumber() +
              "-" +
              getRandomNumber()
            }
          >
            {col.caption ? (
              <div className="basic-table-value" title={val}>
                {col.caption(row, rowIndex)}
              </div>
            ) : (
              <div className="basic-table-value" title={val}>
                {val}
              </div>
            )}
          </div>
        );
      });
      return htmlColumns;
    };

    const renderRows = () => {
      let htmlRows = [];

      htmlRows.push(
        <div
          className="basic-table-row-header"
          key={"header-" + getRandomNumber()}
        >
          {renderHeaderColumns()}
        </div>
      );

      if (datasource) {
        datasource.forEach((row, i) => {
          htmlRows.push(
            <div
              className="basic-table-row"
              key={"row-" + getRandomNumber()}
              onClick={() => (onRowClick ? onRowClick(row, i) : null)}
              onMouseOver={() => (onRowOver ? onRowOver(row, i) : null)}
              onMouseOut={() => (onRowOut ? onRowOut(row, i) : null)}
            >
              {renderColumns(row, i)}
            </div>
          );
        });
      }

      return htmlRows;
    };

    return (
      <div className="basic-table-wrapper">
        {hasValue(title) && <h2 className="basic-table-title">{title}</h2>}
        {renderRows()}
      </div>
    );
  }
);

export default BasicTable;
